export const wait = (ms = 300) =>
	new Promise(resolve => setTimeout(resolve, ms));
